export enum ThemeReferentiel {
  Default = 'Par defaut',
  Office = 'Bureau',
  Classic = 'Classique',
}

export const ThemeKeys = Object.keys(ThemeReferentiel).filter((key) => isNaN(Number(key)));

export const ThemeValues = Object.values(ThemeReferentiel);
